import type { ResolveProceduralDateResult } from '../../../../../backend/src/matter/procedural-timeline/date-resolution';

interface CalculatorLegendProps {
  result: ResolveProceduralDateResult;
}

export function CalculatorLegend({ result }: CalculatorLegendProps) {
  // Even when weekends/holidays count toward the period, the result can still
  // roll over them at the end, so key the swatches off the actual skip list.
  const hasSkippedWeekend = !result.weekendsCount || result.skippedDates.some((s) => s.reason === 'weekend');
  const hasSkippedHoliday =
    !result.publicHolidaysCount || result.skippedDates.some((s) => s.reason === 'public-holiday');
  return (
    <div className="grid grid-cols-3 gap-y-1 text-xs text-gray-600">
      {result.startDateExcluded && <LegendSwatch className="bg-gray-900" label="Start (excluded)" />}
      <LegendSwatch className="bg-violet-100" label="Counted day" />
      {hasSkippedWeekend && <LegendSwatch className="border border-gray-200 bg-white" label="Skipped weekend" />}
      {hasSkippedHoliday && <LegendSwatch className="border border-rose-200 bg-white" label="Skipped holiday" />}
      <LegendSwatch className="bg-teal-100" label="Calculated date" />
      <LegendSwatch className="bg-white ring-2 ring-teal-600 ring-inset" label="Selected date" />
    </div>
  );
}

function LegendSwatch({ className, label }: { className: string; label: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className={`inline-block h-3.5 w-3.5 rounded-sm ${className}`} />
      <span>{label}</span>
    </div>
  );
}
